export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_el-nav-hero-shot/artifacts/um3mzuuq_image1%20%282%29.webp",
  boots: "https://customer-assets.emergentagent.com/job_el-nav-hero-shot/artifacts/zbhj7600_image4%20%281%29.webp",
  saddles: "https://customer-assets.emergentagent.com/job_el-nav-hero-shot/artifacts/5s0xgny3_image5%20%281%29.webp",
  capsEmbroidered: "https://customer-assets.emergentagent.com/job_el-nav-hero-shot/artifacts/szmx6ehc_image3.webp",
  capsDisplay: "https://customer-assets.emergentagent.com/job_el-nav-hero-shot/artifacts/yz6nmjjx_image6%20%281%29.webp",
  desert: "https://images.unsplash.com/photo-1614935981447-893ce3858657?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxkZXNlcnQlMjBzdW5zZXQlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgzNDc3MDcyfDA&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
  {
    id: "botas",
    name: "Botas",
    tagline: "Piel exótica y clásica",
    description: "Avestruz, pitón, cocodrilo y res. Hechas para durar y presumir.",
    image: IMAGES.boots,
  },
  {
    id: "sombreros",
    name: "Sombreros",
    tagline: "Del rancho al baile",
    description: "Texanas de fieltro y palma, más gorras bordadas de edición.",
    image: IMAGES.capsEmbroidered,
  },
  {
    id: "sillas",
    name: "Sillas de Montar",
    tagline: "Talabartería fina",
    description: "Monturas, riendas y cabezadas trabajadas a mano.",
    image: IMAGES.saddles,
  },
  {
    id: "accesorios",
    name: "Accesorios de Cuero",
    tagline: "Detalles que definen",
    description: "Cintos piteados, carteras, hebillas y ropa western.",
    image: IMAGES.capsDisplay,
  },
];

export const TESTIMONIALS = [
  {
    name: "Ramiro Cárdenas",
    role: "Cliente de Hollister",
    quote:
      "Las mejores botas de avestruz que he comprado. Calidad de verdad y el trato es de familia.",
  },
  {
    name: "Lucía Fernández",
    role: "Charra local",
    quote:
      "Encontré una montura preciosa y todo el equipo para mi caballo. El surtido es impresionante.",
  },
  {
    name: "Diego Ruiz",
    role: "Fanático del rodeo",
    quote:
      "El pared de sombreros es una obra de arte. Me llevé una texana que todos me piden dónde la compré.",
  },
  {
    name: "María Elena Vargas",
    role: "Clienta frecuente",
    quote:
      "Cintos piteados, carteras y camisas con estilo. Se siente auténtico, como en México.",
  },
];

export const GALLERY = [
  { image: IMAGES.hero, label: "Nuestra Tienda", span: "col-span-2 row-span-2" },
  { image: IMAGES.boots, label: "Pared de Botas", span: "col-span-1 row-span-1" },
  { image: IMAGES.capsEmbroidered, label: "Gorras de Edición", span: "col-span-1 row-span-1" },
  { image: IMAGES.saddles, label: "Talabartería", span: "col-span-1 row-span-2" },
  { image: IMAGES.capsDisplay, label: "Vitrina de Gorras", span: "col-span-1 row-span-1" },
];

export const STORE = {
  name: "El Navegante Wester",
  addressLine1: "1270 Fourth Street, Ste F",
  addressLine2: "Hollister, CA 95023",
  hoursWeek: "Lun – Sáb · 10:00 AM – 8:00 PM",
  hoursSun: "Dom · 10:00 AM – 6:00 PM",
};
